var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkleGlyph16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SparkleGlyph16x16_svg__a)",
  d: "M9.4 5.08a.506.506 0 0 1 .95 0l.52 1.406a4.05 4.05 0 0 0 2.394 2.394l1.405.52c.441.163.441.787 0 .95l-1.405.52a4.05 4.05 0 0 0-2.394 2.394l-.52 1.405a.507.507 0 0 1-.95 0l-.52-1.405a4.05 4.05 0 0 0-2.394-2.394l-1.405-.52a.506.506 0 0 1 0-.95l1.405-.52A4.05 4.05 0 0 0 8.88 6.486z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SparkleGlyph16x16_svg__b)",
  d: "M3.403 1.265a.405.405 0 0 1 .76 0l.254.687c.206.554.643.992 1.197 1.197l.688.254c.352.13.352.63 0 .76l-.688.254a2.03 2.03 0 0 0-1.197 1.197l-.254.688a.405.405 0 0 1-.76 0l-.254-.688a2.03 2.03 0 0 0-1.197-1.197l-.687-.254a.405.405 0 0 1 0-.76l.687-.254a2.03 2.03 0 0 0 1.197-1.197z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SparkleGlyph16x16_svg__a",
  x1: 1,
  x2: 13,
  y1: 1,
  y2: 13.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8200"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SparkleGlyph16x16_svg__b",
  x1: 1,
  x2: 13,
  y1: 1,
  y2: 13.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8200"
})))));
export default SvgSparkleGlyph16X16;